import { Injectable } from '@angular/core';
import { AppState } from './models/app-state.model';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private readonly _stateFromSession = 'state';
  public store(appState: AppState): void {
    sessionStorage.setItem(this._stateFromSession, JSON.stringify(appState));
  }
  public read(): AppState | undefined {
    const rawState = sessionStorage.getItem(this._stateFromSession);
    if (!rawState) {
      return undefined;
    }
    return JSON.parse(rawState) as AppState;
  }
}
